module.exports = {
	"cn": {
		"answers": [
			"非常赞同",
			"有点赞同",
			"有点不赞同",
			"非常不赞同"
		],
		"questions": [
			{
				"text": "我希望别人认得出我戴的是哪个品牌的首饰（如卡地亚、蒂芙尼等）。"
			},
			{
				"text": "我只会从信得过的珠宝店购买贵重首饰（如周大福，周生生，老凤祥，老庙等）。\n[if ‘Receiver only’]:\n我更喜欢来自信得过的品牌的首饰（如周大福、周生生、老凤祥、老庙等）。"
			},
			{
				"text": "我更喜欢知名品牌的贵重首饰，品质可信。"
			},
			{
				"text": "我喜欢设计大胆的首饰"
			},
			{
				"text": "珠宝首饰最重要的是它的设计。"
			},
			{
				"text": "我宁愿选择比较便宜的金属材质，而将预算更多地用在宝石（如钻石）上。"
			},
			{
				"text": "我更喜欢具有某种特定象征意义的首饰设计（例如心形代表爱）。"
			},
			{
				"text": "首饰是对某个特别的人的纪念。"
			},
			{
				"text": "我多年来带着同一件首饰。"
			},
			{
				"text": "奢侈品让我感觉自己与众不同。"
			},
			{
				"text": "贵金属首饰是一种稳定的投资和资产。"
			},
			{
				"text": "我愿意为可以保值的贵重首饰付出更高的价钱。"
			}
		]
	},
	"en": {
		"answers": [
			"Strongly agree",
			"Rather agree",
			"Rather disagree",
			"Strongly disagree"
		],
		"questions": [
			{
				"text": "I want others to recognize the jewelry brand (e.g., Cartier, Tiffany) I wear"
			},
			{
				"text": "I only buy precious jewelry from trusted jewelry stores (e.g., Chow Seng Seng, Lao feng xiang, Old Temple, etc)\n[if ‘Receiver only’]:\nI prefer precious jewelry from trusted jewelry stores (e.g., Chow Seng Seng, Lao feng xiang, Old Temple, etc)"
			},
			{
				"text": "I prefer -precious jewelry from well-known brands, because I can trust the quality"
			},
			{
				"text": "I like avantgardistic jewelry"
			},
			{
				"text": "Most important about jewelry is the design"
			},
			{
				"text": "I would rather save money on the metal, to allow more to spend on the stone (e.g., diamond)"
			},
			{
				"text": "I prefer jewelry designs that symbolize a particular meaning (e.g., heart symbolize love)"
			},
			{
				"text": "Jewelry is a piece of commemoration of a special person"
			},
			{
				"text": "I wear the same jewelry for years"
			},
			{
				"text": "Luxury products help me to set myself apart from average people"
			},
			{
				"text": "Jewelry made of precious metals is a stable investment asset"
			},
			{
				"text": "I am willing to spend more for precious jewelry that retains its value"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/lang.json
// module id = 605
// module chunks = 0